import { useQuery } from "@tanstack/react-query";
import { getOrgStructureItemsTree } from "../../api/apiOrgStructureItems";
import i18next from "i18next";

/**
 * Flatten nested tree into a flat array with depth level for indented display.
 * Each item gets a `_depth` property and a `_displayName` with prefix.
 */
function flattenTree(nodes, depth = 0) {
    const result = [];
    if (!Array.isArray(nodes)) return result;
    for (const node of nodes) {
        const prefix = depth > 0 ? '│ '.repeat(depth - 1) + '├─ ' : '';
        result.push({
            id: node.id,
            name: prefix + node.name,
            _rawName: node.name,
            _depth: depth,
            allows_multiple: node.allows_multiple,
        });
        if (node.children && node.children.length > 0) {
            result.push(...flattenTree(node.children, depth + 1));
        }
    }
    return result;
}

export function useGetOrgStructureItemsTree() {
    const { isLoading, data, error } = useQuery({
        queryKey: ["orgStructureItemsTree", i18next.language],
        queryFn: () => getOrgStructureItemsTree(),
        retry: false,
    });

    const treeData = data?.data || [];
    const flatItems = flattenTree(treeData);

    return { isLoading, error, treeItems: flatItems };
}
